module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.theForkId) ? _c('div', {
    staticClass: "c-button-book u-flex u-flex-jc--space-between u-flex-ai--center u-bg--black-near u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._onClick()
      }
    }
  }, [_c('div', {
    staticClass: "u-inline-block"
  }, [_c('div', {
    staticClass: "u-relative u-flex u-flex-jc--center"
  }, [_c('div', {
    staticClass: "c-button-book__text-mask u-overflow-h"
  }, [_c('div', {
    staticClass: "c-button-book__text-mask__element u-inline-block t-ffamily--domaine t-text--xxs u-uppercase t-fweight--light u-color--white",
    domProps: {
      "innerHTML": _vm._s(_vm.wordsRegular.join(' ') + '&nbsp;')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "t-ffamily--domaine t-text--xxs u-uppercase t-fweight--bold u-color--white",
    domProps: {
      "innerHTML": _vm._s(_vm.wordsBold)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-button-book__text-bold-mask u-absolute u-pos-l--0 u-pos-y-center u-inline-block u-overflow-h"
  }, [_c('div', {
    staticClass: "c-button-book__text-bold-mask__element u-inline-block t-ffamily--domaine t-text--xxs u-uppercase t-fweight--bold u-color--white",
    domProps: {
      "innerHTML": _vm._s(_vm.wordsRegular.join(' ') + '&nbsp;')
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "c-button-book__icon-container u-relative u-marg-l-xs u-marg-l-xxs@sm u-overflow-h"
  }, [_c('img', {
    staticClass: "c-button-book__icon-container__element u-fit-w",
    attrs: {
      "src": "/static/medias/images/icons/four-seasons_icons_arrow-right--white.png",
      "alt": _vm.label,
      "title": _vm.label
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "c-button-book__icon-container__element--hovered u-absolute u-pos-l--0 u-pos-y-center u-fit-w",
    attrs: {
      "src": "/static/medias/images/icons/four-seasons_icons_arrow-right--white.png",
      "alt": _vm.label,
      "title": _vm.label
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f08c0bc8"}!./src/scripts/components/app-button-book/template.html
// module id = 203
// module chunks = 0